import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Приграничный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p className="sub">Транзитный и трансграничный туризм</p>
                    <p>Брестская область имеет хорошие предпосылки развития этих видов туризма, т.к. по ее территории проходит трансъевропейский коридор Берлин-Варшава-Москва и она имеет общие границы с Украиной, Польшей, является участником объединения «Еврорегион-Буг».</p>
                    <p>Основными направлениями развития транзитного туризма являются:</p>
                    <div className="two-col-cell">
                        <ul>
                            <li>внедрение принципа «зеленого» и «красного» коридоров на действующих погранпереходах;</li>
                            <li>создание на погранпереходе «Варшавский мост» информационно-туристского центра;</li>
                            <li>создание культурно-туристской зоны в СЭЗ «Брест»;</li>
                            <li>развитие придорожной сети объектов туристского обслуживания.</li>
                            <li>Направления развития приграничного туризма:</li>
                            <li>открытие нового погранперехода в Беловежской пуще;</li>
                            <li>организация трансграничных маршрутов через Брест;</li>
                            <li>согласование программ обслуживания иностранных групп ГНП «Беловежская пуща» и в г. Бресте с зарубежными партнерами;</li>
                            <li>организация международных фестивалей, слетов.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}